const renderNothing = () => () => null

export default renderNothing
